import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_DONE,
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST,
} from '../../../../actions/actionTypes';
import { TASK_KEY } from '../../../../services/FacilitatorValidationService';

const done = fetchReducerGenerator(
  [
    FACILITATOR_VALIDATION_CLEAR,
    FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST,
  ],
  FACILITATOR_VALIDATION_DONE
);

export default done;

export const getFacilitatorValidationDoneIsSuccess = state =>
  state.response && state.response.status === HttpStatus.OK.value;

export const getFacilitatorValidationDoneIsTaskFailed = state => {
  if (state.error?.status === HttpStatus.CALL_FAILURE.value) {
    const data = state.error?.data;
    if (data.length > 0) {
      const taskData = data.find(element => element.key === TASK_KEY);
      return Boolean(
        taskData && taskData.status !== HttpStatus.NO_CONTENT.value
      );
    }
  }
  return false;
};
